module.exports = __webpack_public_path__ + "static/media/FoundThreat.54fcf570.svg";